import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import { useCookieConsent } from "../utils/CookieConsent";
import "../Home/HomeQapex.css";
import { Arrow, Icons, QapexNav, QapexFooter, useReveal } from "../Home/QapexChrome";

const bold = { b: (chunk) => <strong>{chunk}</strong> };

// Pagina legale tradotta: `doc` è "privacy" o "cookie" (chiavi legal.<doc> nei dizionari)
const LegalPage = ({ doc }) => {
  const { t } = useTranslation();
  const { openPreferences } = useCookieConsent();
  const rootRef = useRef(null);
  useReveal(rootRef);
  const sections = t(`legal.${doc}.sections`);
  const other = doc === "privacy"
    ? { to: "/cookie-policy", label: t("legal.cookie.title") }
    : { to: "/privacy-policy", label: t("legal.privacy.title") };

  return (
    <div className="qx" ref={rootRef}>
      <Icons />
      <QapexNav t={t} />

      <section className="qa cpage-top legal-top">
        <div className="glow" />
        <div className="wrap">
          <div className="reveal in">
            <div className="eyebrow">{t("home.footer.legal")}</div>
            <h1 className="jobs-title">{t(`legal.${doc}.title`)}</h1>
            <p className="legal-updated">{t("legal.updated")}</p>
          </div>
        </div>
      </section>

      <section>
        <div className="wrap">
          <article className="legal-doc">
            <p className="legal-intro">{t(`legal.${doc}.intro`)}</p>

            {sections.map((section, s) => (
              <div className="legal-sec" key={s}>
                <h2>{section.title}</h2>
                {section.paragraphs?.map((_, p) => (
                  <p key={p}>{t.rich(`legal.${doc}.sections.${s}.paragraphs.${p}`, bold)}</p>
                ))}
                {section.items && (
                  <ul>
                    {section.items.map((_, i) => (
                      <li key={i}>{t.rich(`legal.${doc}.sections.${s}.items.${i}`, bold)}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}

            {doc === "cookie" && (
              <button type="button" onClick={openPreferences} className="btn btn-dark legal-prefs">
                {t("legal.banner.settings")}
              </button>
            )}

            <div className="legal-other">
              <Link to={other.to} className="link">{other.label} <Arrow /></Link>
            </div>
          </article>
        </div>
      </section>

      <QapexFooter t={t} />
    </div>
  );
};

export default LegalPage;
